<div
  class="mtm-pdf-slider-component d-flex"
  *ngIf="filePages"
  [class.collapsed-mode]="collapsed"
  [class.fullscreen]="isFullscreen"
  [class.release-preview]="isReleasePreview"
  [class.share-link-preview]="isShareLinkPreview">
  <div class="left-pane" [class.collapsed]="collapsed">
    <div class="collapse-nav-button d-flex p-2">
      <i class="mtm-icon mtm-icon-expander-vertical pointer" (click)="toggleCollapsed()"></i>
    </div>
    <div class="slide-list-container flex-column" [class.d-none]="collapsed" [class.d-flex]="!collapsed">
      <cdk-virtual-scroll-viewport itemSize="125" #pagesViewport class="pages-viewport">
        <div
          class="slide-list d-flex justify-content-center"
          *cdkVirtualFor="let page of filePages.pages; let idx = index; trackBy: trackByPageId"
          [attr.data-page]="page.rank">
          <!--
          <div class="slide-nav d-flex p-2 align-items-center">
            <i class="mtm-icon mtm-icon-move-element pointer"></i>
          </div>
          -->
          <div
            class="slide-thumbnail flex-fill pointer"
            [class.selected]="activePage?.id == page.id"
            [attr.data-pageid]="page.id"
            (click)="pageSelected(page)">
            <div class="image-thumb">
              <img
                title="Pages {{ page.rank }}"
                [src]="`${page.signedURL}?thumbnail=${page.transcodeMetadata[0]?.quality}`" />
            </div>
            <div class="slide-info px-2">
              <div>Page {{ page.rank }}</div>
              <div class="ms-auto d-flex align-items-center right-items">
                <div class="comment-count" *ngIf="hasCommentCount(page.id)">
                  {{ commentCount[page.id] }}
                </div>
                <div
                  class="page-menu-dropdown"
                  ngbDropdown
                  autoCloseDropdown
                  container="body"
                  [autoClose]="true"
                  (click)="$event.stopImmediatePropagation()"
                  dropdownClass="topic-option-dropdown">
                  <div
                    ngbDropdownToggle
                    class="d-flex align-items-center justify-content-center p-1 edit-item"
                    role="button">
                    <svg width="3" height="10" fill="none">
                      <use xlink:href="/assets/img/selection-grid-edit/three-dot-ellipsis.svg#icon"></use>
                    </svg>
                  </div>
                  <div ngbDropdownMenu>
                    <button
                      ngbDropdownItem
                      class="w-100 d-inline-flex align-items-center btn"
                      (click)="downloadPage(page)">
                      <i class="fa fa-download me-2" Òria-hidden="true"></i>
                      <span class="text-uppercase">{{ 'download' | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
  <!-- <div class="right-pane flex-fill py-3" *ngIf="selectedIndex==-1">
    <div class="slide-list d-flex" *ngFor="let slide of slides;let idx = index">
      <div class="slide-thumbnail flex-fill pointer" [class.selected]="selectedIndex==idx"
        (click)="slideSelected(slide)">
        <div class="image-thumb d-flex">
          <img [src]="slide.signedURL" />
        </div>
        <div class="slide-info p-2">
          <div>{{slide.title}}</div>
          <i></i>
        </div>
      </div>
    </div>
  </div> -->
</div>
